// import React, { Component } from "react";
// import { connect } from "react-redux";

// import Handlers from "reports/containers/HistoricsReportHandlers";
// import HistoricsReportRow from "reports/containers/HistoricsReportRowContainer";
// import * as Reports from "reports/components";

// import { getCompany, getSubcompany, getPermissions } from "auth/selectors";
// import {
//   getHistoricsReportPagination,
//   getHistoricsReportFilters,
//   getHistoricsReportIsLoading,
//   getHistoricsReportVisibleRecords,
// } from "reports/selectors";

// class HistoricsReportContainer extends Component {
//   renderRows = () =>
//     this.props.records.map((record) => (
//       <HistoricsReportRow key={record.id} record={record} />
//     ));

//   render = () => (
//     <Handlers
//       render={({
//         handleFiltersChange,
//         handleFiltersSubmit,
//         handleLimitChange,
//         handleOrderChange,
//         handlePageChange,
//       }) => (
//           <Reports.HistoricsReportView
//             company={this.props.company}
//             count={this.props.records.length}
//             pagination={this.props.pagination}
//             filters={this.props.filters}
//             permissions={this.props.permissions}
//             isLoading={this.props.isLoading}
//             records={this.props.records}
//             subcompany={this.props.subcompany}
//             handleFiltersChange={handleFiltersChange}
//             handleFiltersSubmit={handleFiltersSubmit}
//             handleLimitChange={handleLimitChange}
//             handleOrderChange={handleOrderChange}
//             handlePageChange={handlePageChange}
//           >
//             {this.renderRows()}
//           </Reports.HistoricsReportView>
//         )}
//     />
//   );
// }

// const mapStateToProps = (state) => ({
//   company: getCompany(state),
//   subcompany: getSubcompany(state),
//   pagination: getHistoricsReportPagination(state),
//   permissions: getPermissions(state),
//   filters: getHistoricsReportFilters(state),
//   isLoading: getHistoricsReportIsLoading(state),
//   records: getHistoricsReportVisibleRecords(state),
// });

// export default connect(mapStateToProps, null)(HistoricsReportContainer);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Reports from 'reports/components';
import {
  getHistoricsReportPagination,
  getHistoricsReportFilters,
  getHistoricsReportNeedFetch,
  getHistoricsReportIsLoading,
  getHistoricsReportVisibleRecords,
} from 'reports/selectors';
import {
  getVisibleAccountsParent,
  getVisibleCostCenters,
  getVisibleEmployees,
  getVisibleStatus,
} from 'selectors/lists';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import HistoricsReportRow from 'reports/containers/HistoricsReportRowContainer';
import AssetsFormConfig from 'containers/assets/AssetsFormConfig';
import Handlers from 'reports/containers/HistoricsReportHandlers';

class HistoricsReportContainer extends PureComponent {
  static propTypes = {
    filters: PropTypes.shape({
      fulltext: PropTypes.string.isRequired,
      depreciationType: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
    }).isRequired,
    pagination: PropTypes.shape({
      page: PropTypes.number.isRequired,
      limit: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
      orderBy: PropTypes.string.isRequired,
      order: PropTypes.string.isRequired,
    }).isRequired,
    needFetch: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    assets: PropTypes.array.isRequired,
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
  };

  renderRows = () =>
    this.props.records.map((record) => (
      <HistoricsReportRow
        key={record.id}
        record={record}
        depreciation={this.props.filters.depreciationType}
      />
    ));

  render = () => (
    <AssetsFormConfig
      render={() => (
        <Handlers
          render={({
            handleExport,
            handleExportXLSX,
            handleExportPDF,
            handleFiltersChange,
            handleFiltersSubmit,
            handleLimitChange,
            handleOrderChange,
            handlePageChange,
            handleToggleSearch,
            handleExactSearch,
            columnSearch,
          }) => (
            <Reports.HistoricsReportView
              handleToggleSearch={handleToggleSearch}
              handleExactSearch={handleExactSearch}
              columnSearch={columnSearch}
              accounts={this.props.accounts}
              costCenters={this.props.costCenters}
              employees={this.props.employees}
              status={this.props.status}
              count={this.props.records.length}
              filters={this.props.filters}
              handleExport={handleExport}
              handleExportXLSX={handleExportXLSX}
              handleExportPDF={handleExportPDF}
              handleFiltersChange={handleFiltersChange}
              handleFiltersSubmit={handleFiltersSubmit}
              handleLimitChange={handleLimitChange}
              handleOrderChange={handleOrderChange}
              handlePageChange={handlePageChange}
              isLoading={this.props.isLoading}
              needFetch={this.props.needFetch}
              pagination={this.props.pagination}
              company={this.props.company}
              subcompany={this.props.subcompany}
            >
              {this.renderRows()}
            </Reports.HistoricsReportView>
          )}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  pagination: getHistoricsReportPagination(state),
  filters: getHistoricsReportFilters(state),
  needFetch: getHistoricsReportNeedFetch(state),
  isLoading: getHistoricsReportIsLoading(state),
  records: getHistoricsReportVisibleRecords(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  accounts: getVisibleAccountsParent(state),
  costCenters: getVisibleCostCenters(state),
  employees: getVisibleEmployees(state),
  status: getVisibleStatus(state),
});

export default connect(mapStateToProps, null)(HistoricsReportContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/HistoricsReportContainer.js